import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { Observable, take } from 'rxjs';

import * as AuthActions from '../../core/auth/store/actions/auth.action'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  username$: Observable<string>;
  password$: Observable<string>;
  isLoading$: Observable<boolean>;
  isPasswordVisible = false;

  constructor(private store: Store) {
    this.isLoading$ = this.store.pipe(select((state: any)  => state.auth.isLoading));
    this.username$ = this.store.pipe(select((state: any)  => state.auth.username));
    this.password$ = this.store.pipe(select((state: any)  => state.auth.password));
  }

  onUsernameChange(username: string) {
    this.store.dispatch(AuthActions.updateUsername({ username }));
  }

  onPasswordChange(password: string) {
    this.store.dispatch(AuthActions.updatePassword({ password }));
  }

  ngOnInit() {}

  onSubmit(form: NgForm) {

    this.isLoading$.pipe(take(1)).subscribe((isLoading) => {
        if(!isLoading && form.valid) {
          this.store.dispatch(AuthActions.login());
        }
    });
    return false;
  }
}


